import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../components/Breadcrumb";
import BaseStep from "../../../components/BaseStep";
import { Col, Row } from "antd";
import { useAppSelector } from "../../../hooks";
import { utils } from "../../../utils/utils";
import { giftStatuses } from "../../../../configuration";
import { MethodStatus } from "../../../constants/methodOption";

const GiftHistory = () => {
  const dataPage = useAppSelector((state) => state.pageData);
  const order = dataPage?.data?.data?.order;
  const shippingAddress = dataPage?.data?.data?.shipping_address;
  const [data, setData] = useState(null);

  const checkStatus = () => {
    return MethodStatus.findIndex(
      (item) => item.value === order?.delivery_status
    );
  };

  const handleBack = () => {
    window.location.href = `/my_page`;
  };

  const renderGiftStatus = (item: any) => {
    let giftStatus = giftStatuses.find(
      (status) => status.type === item.gift_status
    );
    let title = (giftStatus.title === "利用済") ? "電子ギフト券利用" : giftStatus.title;
    return (
      <span
        className="amount-gift-status"
        style={{ backgroundColor: giftStatus.bgColor, width: "fit-content", padding: "0 10px" }}
      >
        {title}
      </span>
    );
  };

  useEffect(() => {
    setData(utils.compressOrderItemsHistory(order?.items));
  }, [JSON.stringify(order?.items)]);

  return (
    <>
      <div className="breadcrumb-confirm">
        <Breadcrumb step={true} handleStep={handleBack}>
          注文内容
        </Breadcrumb>
      </div>
      <div className="order-confirm">
        <div style={{ fontSize: "20px", fontFamily: "Noto Sans", fontWeight: "400" }}>
          注文日時：{order?.order_date}
        </div>
        <div className="shipping-address" style={{ marginBottom: "20px" }}>
          <div className="shipping-address__title">お届け先住所</div>
          <div className="name">{shippingAddress?.name}</div>
          <div>{shippingAddress?.postal_code}</div>
          <div>{shippingAddress?.prefecture}</div>
          <div>{shippingAddress?.city}</div>
          <div>{shippingAddress?.town_area}</div>
          <div>{shippingAddress?.phone}</div>
        </div>
        <div className="shipping-details">
          <div className="shipping-title shipping-title__history">
            発送の詳細
          </div>
          {data?.map((item, index) => (
            <div className="order-item my-page__history price-only" key={index}>
              <Row>
                <Col className="history_img" span={12}>
                  <div className="image-item">
                    <img src={item.book_img} alt="book_img"></img>
                  </div>
                </Col>
                <Col span={12} className="col-history">
                  <div className="name-item">
                    <div>{item.book_name}</div>
                    <span style={{ fontSize: "14px", paddingLeft: "6px" }}>
                      ({item.character_name})
                    </span>
                  </div>
                  <div className="gift-item">ギフトケース付き</div>
                </Col>
              </Row>
              <div className="bottom-row">
                <div className="amount">
                  <span>数量：{item.amount}</span>
                  {renderGiftStatus(item)}
                </div>
              </div>
            </div>
          ))}
        </div>
        {order?.status === 'paid' && (
          <>
            <div
              style={{
                fontWeight: "700",
                fontFamily: "Noto Sans",
                fontSize: "20px",
                lineHeight: "20px",
                marginBottom: "28px",
              }}
            >
              発送状況
            </div>
            <Row justify="center">
              <Col>
                <BaseStep
                  responsive={false}
                  steps={MethodStatus}
                  current={checkStatus()}
                />
              </Col>
            </Row>
          </>
        )}
      </div>
    </>
  );
};

export default GiftHistory;
